import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FETCH_LIGHTSPEED_LOCATIONS } from 'router/queries'
import { LightspeedBusiness } from 'components/Integrations/Manage/ManageLightspeed/types'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import { useMessageStore } from 'hooks/useGlobalContext/useMessageStore'
import { useIntegration } from 'hooks/useGlobalContext/useIntegration'
import {
  PartnerName,
  PARTNER_SLUGS,
  isPartner
} from 'components/Integrations/constants'
import { LoaderProps } from './types'
import { useFetchOnce } from './useFetchOnce'

export const LightspeedBusinessesLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const navigate = useNavigate()
  const { addMessage } = useMessageStore()
  const { integrations } = useMerchant()
  const {
    lightspeedBusinesses,
    setLightspeedBusinesses,
    setLightspeedAuthExpired
  } = useIntegration()

  const hasIntegrationConnected = integrations?.some(
    (partner: { partner: { name: string } }) =>
      isPartner(partner.partner.name, PartnerName.LIGHTSPEED)
  )

  const { isLoaded } = useFetchOnce<{
    fetchLightspeedIds: LightspeedBusiness[]
  }>({
    query: FETCH_LIGHTSPEED_LOCATIONS,
    skip: !hasIntegrationConnected || lightspeedBusinesses.length > 0,
    onError: () => {
      if (!hasIntegrationConnected) {
        return
      }

      setLightspeedAuthExpired(true)

      addMessage({
        type: 'message',
        content: 'Your session has expired. Please log in again.'
      })

      navigate(`/integrations/${PARTNER_SLUGS.LIGHTSPEED}`)
    },
    onData: (data) => {
      if (data.fetchLightspeedIds) {
        setLightspeedBusinesses(data.fetchLightspeedIds)
        setLightspeedAuthExpired(false)
      }
    },
    isReady: (loading) => !hasIntegrationConnected || !loading,
    isParentLoaded
  })

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
